<template>
  <div style="color:#6c757d !important;">
    <!-- ----------------------------------- -->
    <!-- navbar starts -->
    <vs-navbar
      v-model="indexActive"
      :color="colorx"
      text-color="rgba(255,255,255,.6)"
      active-text-color="rgba(255,255,255,1)"
      class="myNavbar"
    >
      <div slot="title">
        <vs-navbar-title>Graphs Presentations</vs-navbar-title>
      </div>
    </vs-navbar>
    <!-- navbar ends -->
    <!-- ----------------------------------- -->
    <!-- container starts -->
    <div class="container mt-5">
      <div class="row">
        <div class="col-sm-12 p-0 print-scr">
          <span class="btn btn-primary float-right btn-sm print-btn" @click="printReport">
            <i class="material-icons">print</i> Print
          </span>
          <vs-breadcrumb
            align="left"
            :items="
                  [
                   {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/program-officer/todoList'
                    },
                    {
                      title: 'Reports',
                      url: '/#/',
                      active: true
                    }
                  ]"
          ></vs-breadcrumb>
        </div>
      </div>
    </div>
    <div class="container container-bdr mt-2 mb-5">
      <!-- row starts -->
      <div class="row">
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-12 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Pre Assessment Report</strong>
            </span>
            <span class="float-right">
              <strong>Training Code :</strong> {{details.training_code}}
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom">
          <img :src="basepath+'/unodc_logo.png'" class="mt-2 mb-2" alt="UNODC" width="200" />
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Plot # 5-11, Diplomatic Enclave, G-5, P.O.BOX 1051, Islamabad 44000, Pakistan</strong>
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Country Office Pakistan</strong>
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-12 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Name of Event :</strong> {{details.title}}
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-6 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Start Date :</strong> {{details.startdate}}
            </span>
          </p>
        </div>
        <div class="col-md-6 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Finish Date :</strong> {{details.enddate}}
            </span>
          </p>
        </div>
        <!-- col-md starts -->
       <!--  <div class="col-md-4 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Position :</strong>
            </span>
          </p>
        </div> -->
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <!-- <div class="col-md-4 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Grade :</strong>
            </span>
          </p>
        </div> -->
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <!-- <div class="col-md-4 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Organization:</strong>
            </span>
          </p>
        </div> -->
        <!-- col-md ends -->
        <!-- <div class="col-md-6 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Gender :</strong> Female
            </span>
          </p>
        </div> -->
        <!-- col-md starts -->
        <!-- <div class="col-md-6 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>District :</strong>Peshawar
            </span>
          </p>
        </div> -->
     
        <table class="table text-justify vertical-justify">
          <tbody v-if="feedbackQuestions">
            <tr v-for="(question,index) in feedbackQuestions" :key="index" style="border-bottom:1px solid #dee2e6 !important">
              <td>{{index+1}}</td>
              <td class="question">{{question.qtitle}}</td>
              <span v-for="(option,oindex) in feedbackQuestionOptions" :key="oindex" style="">
                <td class="answer" v-if="question.qid == option.oquestionBank_id" style="padding:10px 20px" >
                <template  v-if="question.selectedOption == option.oid">
                   <input type="radio" class="form-check-input" checked disabled/>
                    <strong>{{option.otitle}}</strong>
                </template>
                <template  v-else>
                   <input type="radio" class="form-check-input" disabled/>
                    {{option.otitle}}
                </template>
                </td>
              </span>
            </tr>
           
          </tbody>
         
        </table>
      </div>
      <!-- row ends -->
    </div>
    <!-- container ends -->
  </div>
</template>

<script>
// import Chart from "chart.js";
import axios from "axios";
export default {
  data: () => ({
    radios1: true,
    radios2: false,
    radios3: false,
    traineeId : "",
    training_id:"",
    details:[],
    feedbackQuestions :[],
    feedbackQuestionOptions:[],
    radios4: false,
    radios5: false,
    colorx: "#2196f3",
    basepath: process.env.VUE_APP_BASE_PATH,
    indexActive: 0
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.traineeId = this.$route.query.traineeId;
    this.training_id = this.$route.query.trainingId;
    this.TrainingDetail();
    this.allQuestions();
  },
  methods: {
    allQuestions: function allQuestions() {
    axios.get(process.env.VUE_APP_BASE_PATH+'/show/trainee-preassesment/report/'+this.traineeId+'/'+this.training_id).then(response => {
      if(response.data && response.data.questionArray){
        this.feedbackQuestions = response.data['questionArray'];
      }
      if(response.data && response.data.optionArray){
          this.feedbackQuestionOptions = response.data['optionArray'][0];
      }
    });
  },
  TrainingDetail: function TrainingDetail() {
    axios.get(process.env.VUE_APP_BASE_PATH+'/show/trainee-preassesment/trainingDetail/report/'+this.traineeId+'/'+this.training_id).then(response => {
      if(response.data){
        this.details = response.data;
      }
    });
  },
    printReport: function() {
      window.print();
    }
  }
};
</script>
<style scoped>
.myNavbar {
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1), 0 5px 5px rgba(0, 0, 0, 0.1) !important;
}
.container-bdr {
  border-top: 2px solid #2196f36b;
  border-right: 2px solid #2196f36b;
  border-left: 2px solid #2196f36b;
  border-bottom: 2px solid #2196f36b;
}
.col-bdr-bottom {
  border-bottom: 0.5px solid #2196f36b;
  border-left: 0.5px solid #2196f36b;
}
.nav-route-link {
  background: none !important;
  border-right: 0px !important;
}
.chart-container {
  position: relative;
  margin: auto;
  height: 340px;
  width: 340px;
}
.chart-container-sm {
  position: relative;
  margin: auto;
  height: 250px;
  width: 250px;
}
.vs-checkbox--check.vs-icon {
  font-size: 11px !important;
}
.line-bordered {
  border: 0.5px solid #2196f36b;
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}
td.question {
  width: 50%;
  padding-right: 30px;
}
/* td.answer {
  width: 50%;
} */
.table th, .table td{
  border:none !important;
}


@media print {
  .print-btn {
    display: none;
  }
  .col-bdr-bottom {
    border-bottom: none !important;
    border-left: none !important;
  }
  .container-bdr {
    border-top: none !important;
    border-right: none !important;
  }
}
</style>
<style>
.vs-navbar--header {
  height: 60px;
  padding: 20px;
}
.vs-con-items {
  padding: 20px;
}
@media screen and (max-width: 800px) {
  .vs-con-items.activeMenuResponsive {
    background-color: #46637a !important;
  }
}
</style>